// removed by extract-text-webpack-plugin
module.exports = {"badge-wrap":"badge-wrap___2eR4u center___2iqBf","badge-wrap-small":"badge-wrap-small___rfKll badge-wrap___2eR4u center___2iqBf","badge":"badge___33ZVy","badge-active":"badge-active___1Ipbi badge___33ZVy","badge-inactive":"badge-inactive___24V-Q badge___33ZVy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Badges/Badges.css
// module id = 854
// module chunks = 0